// MobileHotels.jsx
import React, { useState } from 'react';
import Banner from './Banner';
import Activities from './Activities/Activities';
import Hotels from './Hotels';
import { CounterSection, Footer, Testimonials } from './Footer';

const MobileHotels = () => {
  const [searchLocation, setSearchLocation] = useState('');
  const [selectedLocationType, setSelectedLocationType] = useState('');

  const handleLocationSelect = (location) => {
    setSearchLocation(location);
  };

  const handleLocationTypeSelect = (locationType) => {
    setSelectedLocationType(locationType);
  };

  return (
    <div className="min-h-screen bg-gray-50">
      <div className="container mx-auto px-4">
        <Banner 
          onLocationSelect={handleLocationSelect}
          onLocationTypeSelect={handleLocationTypeSelect}
        />
        <Activities selectedLocation={searchLocation} />
        <Hotels 
          searchLocation={searchLocation}
          selectedLocationType={selectedLocationType}
        />
        <CounterSection />
        <Testimonials />
        <Footer />
      </div>
    </div>
  );
};

export default MobileHotels;